import clsx from 'clsx';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { Icon } from '@gitbook/spine-icons';
import { AtomLink, type AtomLinkProps, HeadingContext } from '@gitbook/spine-react';

// This could eventually be moved to spine-react at some point but for now it's only used in the site overview

export const SiteOverviewSection = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(
    function SiteOverviewSection(props, ref) {
        return (
            <div {...props} ref={ref} className={clsx('flex flex-col gap-2', props.className)} />
        );
    }
);

export const SiteOverviewSectionHeader = forwardRef<
    HTMLDivElement,
    ComponentPropsWithoutRef<'div'>
>(function SiteOverviewSectionHeader(props, ref) {
    return (
        <HeadingContext.Provider value={{ level: 2, className: 'text-ui-heading-small' }}>
            <div
                {...props}
                ref={ref}
                className={clsx('flex items-center justify-between gap-4 px-2', props.className)}
            />
        </HeadingContext.Provider>
    );
});

export const SiteOverviewSectionLink = forwardRef<HTMLAnchorElement, AtomLinkProps>(
    function SiteOverviewSectionLink(props, ref) {
        return (
            <AtomLink {...props} ref={ref} className="group flex items-center gap-1">
                {props.children}
                <Icon.ArrowRight className="shrink-0 transition group-hover:translate-x-1" />
            </AtomLink>
        );
    }
);
